<template>
    <div class="sr-input-box">
        <div class="sr-input-box-wrapper" :class="{ clickable: isClickable, active: active }" @click="emitClick">
            <div class="before">
                <slot name="before" />
            </div>
            <div class="main" :class="{ 'with-before-slot': isBeforeSlotSet }">
                <slot />
            </div>
            <div class="after">
                <slot name="after" />
            </div>
        </div>
        <div v-if="label" class="sr-input-box-label">
            {{ label }}
        </div>
    </div>
</template>
<script>
export default {
    name: 'SrInputBox',
    props: {
        label: {
            type: String,
            default: null,
        },
        active: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isBeforeSlotSet() {
            return !!this.$slots.before;
        },
        isClickable() {
            return !!this.$listeners.click;
        },
    },
    methods: {
        emitClick() {
            if (this.isClickable) {
                this.$emit('click');
            }
        },
    },
};
</script>
